// Whether the Customise drawer is open.
//
// Module-level because two places open it: the navigation bar on the
// engineering and trend pages, and the Overview's own top strip — the Overview
// hides the bar entirely, so it needs its own way in.

import { ref } from 'vue'

const open = ref(false)

export function useDrawer() {
  return {
    open,
    show: () => {
      open.value = true
    },
    hide: () => {
      open.value = false
    },
  }
}

// Module-level singleton state: a hot update would hand new refs to some
// components while others keep the old ones, and the page would half-work until
// a manual reload. Escalate the update to a full reload instead.
if (import.meta.hot) {
  import.meta.hot.accept(() => import.meta.hot.invalidate())
}
